module.exports = __webpack_public_path__ + "img/qr-code.3c2bbd51.jpg";